<template>
  <div
    class="empty-table-wrapper"
    @scroll="setScollToViewPosition"
    :style="{borderRadius : HasParent ? '0 0 10px 10px' : '10px', pointerEvents : Loading ? 'none' :'auto' }"
  >
    <section
      class="empty-table__scroll-container"
      :style="{ minWidth : emptyTableMinWidth + 'px'}"
    >
      <section
        class="empty-table-header"
        :style="{height:propsHeaderHeight + 'px', opacity: Loading? '0.3' : '1'}"
      >
        <div
          class="empty-table-header__content"
          v-for="item in ColumnData"
          :style="{width: item.width}"
        >
          {{ item.label }}
        </div>
      </section>
      <section
        class="empty-table-body__fake"
        :style="{height: EmptyBodyHeight + 'px'}"
      />
    </section>
    <div
      class="empty-table-body__fixed"
      ref="emptyRef"
      :style="{height: 'calc(100% - ' + propsHeaderHeight + 'px)', top: propsHeaderHeight+'px' }"
    >
      <el-spinner 
        v-if="Loading"
        :v-else="85"
        :stroke-width="2"
      />
      <warning-message 
        v-else-if="!Loading && IsIcon" 
        :message="Message" 
      />
      <h3 
        v-else-if="!Loading && !IsIcon"
        class="empty-guide-text" 
      >
        {{ Message }}
      </h3>
      <a
        class="empty-guide-text initialized-text" 
        v-if="!Loading && propsInitialzed && propsIsFiltered"
        href="#"
        @click="propsInitialzed.handler"
      >
        {{ propsInitialzed.message }}
      </a>
    </div>
  </div>
</template>

<script>
import WarningMessage from '@/components/element-ui/WarningMessage';

export default {
  data() {
    return {
      ColumnData: this.propsData,
      EmptyBodyHeight: this.propsTableBodyHeight,
      Message: this.propsMessage,
      HeaderHeight: this.propsHeaderHeight,
      HasParent: this.propsHasParent,
      IsIcon: this.propsIsIcon,
      label: this.label,
      emptyTableMinWidth: this.propsMinWidth
    };
  },
  computed: {
    Loading: function() {
      return this.propsLoadingStatus;
    }
  },
  components: { WarningMessage },
  props: {
    propsData: {
      type: Array,
      default: []
    },
    propsTableBodyHeight: {
      type: Number,
      default: 100
    },
    propsMessage: {
      type: String,
      default: '데이터 없음'
    },
    propsHeaderHeight: {
      type: Number,
      default: 43
    },
    propsHasParent: {
      type: Boolean,
      default: false
    },
    propsIsIcon: {
      type: Boolean,
      default: true
    },
    propsLoadingStatus: {
      type: Boolean,
      default: true
    },
    propsMinWidth: {
      type: Number | String,
      default: 1000
    },
    propsInitialzed: {
      type: null | Object,
      default: null
    },
    propsIsFiltered: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setScollToViewPosition: function(event) {
      event.preventDefault();
      const TABLE_MAX_WIDTH = 1000;
      const { scrollLeft } = event.target;
      const { style: refStyle, clientWidth } = this.$refs.emptyRef;
      const isOverScroll = clientWidth + scrollLeft > TABLE_MAX_WIDTH;

      //below logic is to respond to safari crossbrowsing.(overscroll bouncing)
      if (isOverScroll) {
        return;
      }
      refStyle.left = scrollLeft + 'px';
    }
  }
};
</script>

<style lang="scss">
.empty-table-wrapper {
  position: relative;
  width: 100%;
  background-color: white;
  overflow: auto;
  .empty-table__scroll-container {
    position: relative;
    overflow: hidden;
    .empty-table-header {
      background-color: #e3e3e3;
      display: flex;
      flex-wrap: nowrap;
      .empty-table-header__content {
        margin: auto 0;
        font-size: 13px;
        height: 19px;
        font-weight: 300;
        padding-left: 10px;
        letter-spacing: -0.8px;
        color: #4a4a4a;
        text-align: left;
      }
    }
  }
  .empty-table-body__fixed {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .empty-guide-text {
    font-size: 14px;
    font-weight: 400;
    color: #909399;
    margin: 0;
    letter-spacing: -0.8px;
  }

  .initialized-text {
    text-decoration: underline;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media screen and (max-width: 768px) {
  .empty-table__scroll-container {
    width: 1000px;
  }
}
</style>
